/* Smooth scrolling only (Lenis). The theme's own on-view animations are left exactly as they were. */
(function () {
  'use strict';
  if (window.__hnFx) return;
  window.__hnFx = true;
  var root = document.documentElement;
  try {
    if ((window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) || (window.Shopify && Shopify.designMode) || window.self !== window.top) return;
  } catch (e) {}

  var st = document.createElement('style');
  st.textContent = 'html.lenis,html.lenis body{height:auto}.lenis.lenis-smooth{scroll-behavior:auto!important}.lenis.lenis-stopped{overflow:hidden}.lenis.lenis-scrolling iframe{pointer-events:none}';
  document.head.appendChild(st);

  var asked = false;
  function startLenis() {
    if (window.lenisInstance || !window.Lenis) return;
    var lenis = new Lenis({ autoRaf: true, lerp: 0.1, duration: 1.2, wheelMultiplier: 1, easing: function (x) { return Math.min(1, 1.001 - Math.pow(2, -10 * x)); } });
    window.lenisInstance = lenis;
    if (root.classList.contains('hn-lock')) lenis.stop();
  }
  function loadLenis() {
    if (asked) return;
    asked = true;
    if (window.Lenis) { startLenis(); return; }
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/lenis@1.1.19/dist/lenis.min.js';
    s.async = true;
    s.onload = startLenis;
    document.head.appendChild(s);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadLenis); else loadLenis();
})();